/* app/js/src/components/media-transcoder/jobs/history/history-bulk-redo-dialog/history-bulk-redo-dialog.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.bulk-redo-container {
  width: min(92vw, 72rem);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  padding: 0.5vw 0;
}
.bulk-redo-container .header {
  margin-bottom: 0.75vw;
  flex-shrink: 0;
  align-items: center;
}
.bulk-redo-container .header h3 {
  margin: 0;
  color: #232f3a;
  font-weight: 600;
}
.bulk-redo-container .header .dialog-close-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  color: #5a6a7a;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 4px;
}
.bulk-redo-container .header .dialog-close-btn:hover {
  background: #eef2f5;
  color: #232f3a;
}
.bulk-redo-container .toolbar {
  gap: 0.6vw;
  margin-bottom: 0.75vw;
  flex-shrink: 0;
}
.bulk-redo-container .toolbar .toolbar-row {
  gap: 1vw;
  align-items: flex-end;
}
.bulk-redo-container .toolbar .toolbar-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.bulk-redo-container .toolbar .field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #232f3a;
}
.bulk-redo-container .toolbar .filter-input-row {
  gap: 0.5rem;
}
.bulk-redo-container .toolbar .filter-input {
  min-width: 12rem;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  box-sizing: border-box;
}
.bulk-redo-container .toolbar .range-group {
  gap: 0.5vw;
}
.bulk-redo-container .toolbar .range-input {
  width: 4rem;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
}
.bulk-redo-container .toolbar .link-btn {
  background: none;
  border: none;
  color: #40c4ff;
  cursor: pointer;
  padding: 0;
  font-size: 0.9rem;
}
.bulk-redo-container .toolbar .link-btn:hover:not(:disabled) {
  text-decoration: underline;
}
.bulk-redo-container .toolbar .link-btn:disabled {
  color: #999;
  cursor: default;
}
.bulk-redo-container .toolbar .reschedule-toggle {
  display: flex;
  align-items: center;
  gap: 0.5vw;
  font-size: 0.9rem;
  color: #232f3a;
  cursor: pointer;
}
.bulk-redo-container .toolbar .reschedule-toggle input {
  cursor: pointer;
}
.bulk-redo-container .toolbar .hint {
  margin: 0;
  font-size: 0.85rem;
  color: #666;
}
.bulk-redo-container .table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
}
.bulk-redo-container .jobs-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  color: #232f3a;
  font-size: 0.85rem;
}
.bulk-redo-container .jobs-table th,
.bulk-redo-container .jobs-table td {
  padding: 0.35rem 0.5rem;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bulk-redo-container .jobs-table th {
  position: sticky;
  top: 0;
  background: #f5f7f9;
  z-index: 1;
  font-weight: 600;
}
.bulk-redo-container .jobs-table tr:nth-child(even) {
  background: #fdfdfd;
}
.bulk-redo-container .jobs-table col.col-check {
  width: 2rem;
}
.bulk-redo-container .jobs-table col.col-num {
  width: 2.5rem;
}
.bulk-redo-container .jobs-table col.col-name {
  width: 22%;
}
.bulk-redo-container .jobs-table col.col-destination {
  width: 16%;
}
.bulk-redo-container .jobs-table col.col-profile {
  width: 14%;
}
.bulk-redo-container .jobs-table col.col-failed {
  width: 9.5rem;
}
.bulk-redo-container .jobs-table col.col-status {
  width: 12%;
}
.bulk-redo-container .jobs-table col.col-side-effect {
  width: 12%;
}
.bulk-redo-container .jobs-table .col-failed {
  white-space: nowrap;
  font-size: 0.8rem;
}
.bulk-redo-container .state-message {
  padding: 2rem;
  text-align: center;
  color: #666;
}
.bulk-redo-container .state-message .filter-hint {
  margin: 0.5rem 0 0;
  font-size: 0.85rem;
  color: #888;
}
.bulk-redo-container .footer {
  margin-top: 0.75vw;
  flex-shrink: 0;
  gap: 1vw;
}
.bulk-redo-container .footer .selection-summary {
  font-size: 0.9rem;
  color: #232f3a;
}
.bulk-redo-container .footer .footer-actions {
  gap: 0.75vw;
  flex-shrink: 0;
}
/*# sourceMappingURL=history-bulk-redo-dialog.component.css.map */
